import { Login, LoginForm } from "react-admin";

import { Typography } from "@mui/material";

const LoginPage = () => (
  <Login
    backgroundImage="/images/ash-edmonds-gcINRBbUxl0-unsplash.jpg"
    children={
      <>
        <Typography variant="h4" color="textPrimary" textAlign="center">
          blueconf
        </Typography>
        <Typography
          variant="caption"
          display="block"
          color="CaptionText"
          textAlign="center"
          sx={{ marginBottom: 2 }}
        >
          networkteam GmbH
        </Typography>
        <LoginForm />
      </>
    }
  />
);

export default LoginPage;
